import { identity, transformPoint, validateRigid, type Point3 } from './rigid';
export function multiply(a: number[], b: number[]) {
  return Array.from({ length: 16 }, (_, index) => { const r = Math.floor(index/4); const c = index%4; return [0,1,2,3].reduce((sum,k) => sum+a[r*4+k]*b[k*4+c],0); });
}
/** Target-axis Euler increments around a fixed target-space pivot, in mm. */
export function rotateAbout(matrix: number[], degrees: Point3, pivot: Point3) {
  if ([...degrees,...pivot].some(n => !Number.isFinite(n))) throw new Error('Rotation and pivot must be finite.');
  let rotation = identity();
  degrees.forEach((degree, axis) => {
    const angle = degree*Math.PI/180; const c=Math.cos(angle); const s=Math.sin(angle); const r=identity();
    const u=(axis+1)%3; const v=(axis+2)%3; r[u*4+u]=c; r[v*4+v]=c; r[u*4+v]=-s; r[v*4+u]=s;
    rotation=multiply(r,rotation);
  });
  const rotated = transformPoint(rotation,pivot); pivot.forEach((n,i) => { rotation[i*4+3]=n-rotated[i]; });
  const result=multiply(rotation,matrix); validateRigid(result); return result;
}
